export const SCROLL_INTO_VIEW_EVT = 'scrollIntoViewEvt';